module.exports = __webpack_public_path__ + "img/Logo.24536c72.png";